"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectAnnouncements = void 0;
const selectAnnouncements = (state) => state.game.announcements.items;
exports.selectAnnouncements = selectAnnouncements;
